@if (shouldShow()) {
  <cfp-alert
    [title]="'buildingNotification.' + type() + '.title'"
    [alertStyle]="'notify'"
    [icon]="'info-circle'"
    [classes]="'mb-5'"
    [canDismiss]="true"
    (dismissed)="dismiss()"
    >
    {{ 'buildingNotification.' + type() + '.body' | cfpTranslate }}
  </cfp-alert>
}